export default __webpack_public_path__ + "static/media/Thassia 1.367dc17b.svg";